import { isEmpty } from 'lodash';
import { downloadCsvFromJson } from '../../../utils/fileGeneration';
import { SnackbarSeverityType } from '../../../enums';

type StaffAttendanceReportData = {
  data: any;
  showToast: (msg: string, severity: SnackbarSeverityType) => void;
  successMessage?: string;
  unsuccessfulFileName?: string;
  unsuccessfulSheetName?: string;
};

function handleStaffAttendanceUpload({
  data,
  showToast,
  successMessage = 'File uploaded successfully.',
  unsuccessfulFileName = 'unsuccessful-staff-attendance-records',
  unsuccessfulSheetName = 'Unsuccessful Records'
}: StaffAttendanceReportData) {
  if (!isEmpty(data?.unsuccessfulRecords)) {
    const headers = Object.keys(data?.unsuccessfulRecords[0] || {});
    const preferredOrder = ['Code', 'Email'];
    const unsuccessfulHeaders = [
      ...preferredOrder.filter((header) => headers.includes(header)),
      ...headers.filter((header) => !preferredOrder.includes(header))
    ];

    const unsuccessfulBody = data?.unsuccessfulRecords.map((row: any) =>
      unsuccessfulHeaders.map((header) => row[header] ?? '')
    );
    downloadCsvFromJson(unsuccessfulFileName, unsuccessfulSheetName, {
      headers: unsuccessfulHeaders,
      body: unsuccessfulBody
    });
    showToast(
      'Some records could not be uploaded. Please check the downloaded CSV for details.',
      SnackbarSeverityType.error
    );
  } else {
    showToast(successMessage, SnackbarSeverityType.success);
  }
}

export { handleStaffAttendanceUpload, StaffAttendanceReportData };
